import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import ForgetPasswordService from '../forget-password-service.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import Service from '@/service/index.js';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      processList: ['验证身份', '重置密码', '重置成功'],
      step: 1,
      form: {
        mobile: '',
        verifyCode: '',
        assignorCode: '',
        userType: ''
      },
      supplyType: [], // 用户类型
      rules: {
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        assignorCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'captchaImageSrc',
      'ticket',
      'userType'
    ])
  },
  created() {
    const obj = {
      USER_TYPE: 'supplyType'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
    this.updateCaptchaImage();
  },
  mounted() {
    this.form.mobile = this.userInfo && this.userInfo.mobile;
  },
  methods: {
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 获取手机验证码
    getSmsCode() {
      const mobile = this.form.mobile;
      if (!mobile) {
        errorMessage('请输入正确的手机号');
        return;
      }
      if (!this.form.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (this.form.verifyCode && this.form.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      const form = {mobile: mobile, ticket: this.ticket, verifyCode: this.form.verifyCode};
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCode', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '重新获取';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    // 下一步
    nextStep() {
      if (!this.validateForm()) { return; };
      let params = {
        mobile: this.form.mobile,
        verifyCode: this.form.assignorCode
      };
      ForgetPasswordService.authenticate(params).then(res => {
        if (res && res.code === '0') {
          // console.log('下一步');
          this.$router.push('/forget-password/amend-spassword?mobile=' + this.form.mobile + '&userType=' +this.form.userType);
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
